const options = {
  1: "xl:col-end-1",
  2: "xl:col-end-2",
};

export default function getGridColEndXl(start) {
  return options[start];
}
